<template>
    <div id="app">
        <div class="container">
            <Navbar />
        </div>
        <router-view />
    </div>
</template>

<script>
    import Navbar from './components/Navbar.vue'
    import store from './store'
    import { getInstance } from '@/auth'

    export default {
        name: 'App',
        store,
        components: {
            Navbar
        },
        data() {
            return {
                authToken: false
            }
        },
        created() {
            this.init(this.loadTokenIntoStore);
        },
        methods: {
            init(fn) {
                // have to do this nonsense to make sure auth0Client is ready
                var instance = getInstance();
                instance.$watch("loading", loading => {
                    if (loading === false) {
                        fn(instance);
                    }
                });
            },
            async loadTokenIntoStore(instance) {
                await instance.getTokenSilently().then((authToken) => {
                    // do authorized API calls with auth0 authToken here
                    // or load authToken in state store for other components to use
                    store.commit('changeTitle', authToken)
                    localStorage.setItem('accessToken', authToken);
                    this.authToken = true;
                });
            },
            created() {
                //this.$cookie.set("keyName", keyValue, "expiring time")
                //console.log(localStorage.getItem('accessToken'));
            }
        }
    }
</script>


<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 0px;
    }
</style>
